import { PortResponse } from "~/types/api";

export type BinState = ActivityState | BinAnimationCategory;

const binAnimationCategories = [
  "In Grid",
  "On Robot",
  "In Port",
  "Other Port"
] as const;
export type BinAnimationCategory = (typeof binAnimationCategories)[number];

export const getIsBinAnimationCategory = (
  state: string | undefined
): state is BinAnimationCategory =>
  !!state && binAnimationCategories.includes(state as BinAnimationCategory);

/*
  Waiting: Waiting for a bin
  Active: Bin is present
  Inactive: Bin is not present
  Closed: Port is closed
 */
export type ActivityState =
  | "Waiting for Bin"
  | "Bin Opened"
  | "Inactive"
  | "Port Closed";

export const activityStateFromPortResponse = (
  portState?: PortResponse,
  isThisFusionSideOpen?: boolean
): ActivityState => {
  const openPortNoBin =
    portState?.mode === "OPEN" && portState?.selectedBin === 0;
  if (!portState) return "Port Closed";
  if (portState.mode === "CLOSED") return "Port Closed";
  if (
    (portState.isReady &&
      isThisFusionSideOpen !== undefined &&
      !isThisFusionSideOpen) ||
    openPortNoBin
  )
    return "Inactive";
  if (portState.isReady) return "Bin Opened";
  return "Waiting for Bin";
};
